/* Updated 2026-09-03 / kaho + Codex. Uses fresh Shopify section-rendered values. */
(() => {
  function apply(root, state) {
    if (!state || String(state.product_id) !== root.dataset.productId) return false;
    const values = state.values || {};
    root.dataset.variantId = state.variant_id == null ? '' : String(state.variant_id);
    root.dataset.variantSku = state.variant_sku || '';
    for (const row of root.querySelectorAll('[data-fdp-spec-row]')) {
      const value = values[row.dataset.fdpSpecRow];
      const text = typeof value === 'string' ? value : '';
      row.querySelector('[data-fdp-spec-value]').textContent = text;
      row.hidden = text.trim() === '';
    }
    for (const group of root.querySelectorAll('[data-fdp-spec-group]')) {
      group.hidden = !Array.from(group.querySelectorAll('[data-fdp-spec-row]')).some(row => !row.hidden);
      if (group.hidden) group.open = false;
    }
    return true;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {apply};
  else window.FdpProductSpecs = {apply};
})();
